export default {
    approvals: {
        title: "Aprobación",
        error: "Se produjo un error"
    },
    delegates: {
        title: "Delegados",
        error: "Se produjo un error",
        noDelegates: "No hay artículos",
        delegateDelete: "El delegado ha sido eliminado",
        confirm: {
            delete: "¿Borrar delegado?"
        },
        delegates: {
            email: "Correo electrónico",
            startDate: "Fecha de inicio",
            endDate: "Fecha de finalización",
        },
        buttons: {
            add: {
                text: "Agregar delegado"
            }
        }
    },
    employees: {
        title: "Mis empleados",
        error: "Se produjo un error",
        empty: "No se encontraron empleados",
        users: {
            name: "Nombre",
            email: "Correo electrónico"
        },
        model: {
            search: {
                placeholder: "Buscar",
            }
        },
        cta: {
            orders: "Órdenes de carga",
            download: "Descargar pedidos",
            search: "Buscar"
        }
    }
}